module.exports = __webpack_public_path__ + "static/media/psurveyPrintTemplate.faad6962.txt";